import React, { useState, useRef } from "react";
import {
  getField,
  isElementThisPercentInViewport,
} from "../../../../util/DynamicItemUtils";

export default function RegisteredFirms({ item }: any) {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef<HTMLInputElement>(null);

  const auditReportTooltip =
    "Audit report activity as reported by the firm in its annual reports for the three most recent annual reporting periods";

  function checkTooltipPosition() {
    return !!tooltipRef && !!tooltipRef.current
      ? !isElementThisPercentInViewport(tooltipRef.current, 100)
        ? " reposition"
        : ""
      : "";
  }

  return (
    <div className="registered-firms">
      <div>
        <h3 className="break-word">{getField(item, "firmname")}</h3>
        <p>
          <strong>City:</strong>
          {getField(item, "firmcity") && ` ${getField(item, "firmcity")}`}
        </p>
        <p>
          <strong>State:</strong>
          {getField(item, "firmstate") && ` ${getField(item, "firmstate")}`}
        </p>
        <p>
          <strong>Country:</strong>
          {getField(item, "firmcountry") && ` ${getField(item, "firmcountry")}`}
        </p>
        <div className="registered-firms__audit-notes">
          <div>
            {getField(item, "category") &&
              item.Document.category.map((cat, i) => {
                return <p key={`category_${i}`}>{cat}</p>;
              })}
          </div>
          <div>
            <div
              className="audit-tooltip"
              onClick={() => setShowTooltip(!showTooltip)}
            >
              <svg
                viewBox="0 0 24 24"
                className="icon"
                focusable="false"
                aria-hidden="true"
              >
                <path d="M 10.976562 14.785156 C 10.976562 15.324219 10.539062 15.761719 10 15.761719 C 9.460938 15.761719 9.023438 15.324219 9.023438 14.785156 C 9.023438 14.246094 9.460938 13.808594 10 13.808594 C 10.539062 13.808594 10.976562 14.246094 10.976562 14.785156 Z M 10.976562 14.785156 " />
                <path d="M 10 0 C 4.472656 0 0 4.472656 0 10 C 0 15.527344 4.472656 20 10 20 C 15.527344 20 20 15.527344 20 10 C 20 4.472656 15.527344 0 10 0 Z M 10 18.4375 C 5.335938 18.4375 1.5625 14.664062 1.5625 10 C 1.5625 5.335938 5.335938 1.5625 10 1.5625 C 14.664062 1.5625 18.4375 5.335938 18.4375 10 C 18.4375 14.664062 14.664062 18.4375 10 18.4375 Z M 10 18.4375 " />
                <path d="M 10 5.019531 C 8.277344 5.019531 6.875 6.421875 6.875 8.144531 C 6.875 8.574219 7.226562 8.925781 7.65625 8.925781 C 8.085938 8.925781 8.4375 8.574219 8.4375 8.144531 C 8.4375 7.28125 9.136719 6.582031 10 6.582031 C 10.863281 6.582031 11.5625 7.28125 11.5625 8.144531 C 11.5625 9.007812 10.863281 9.707031 10 9.707031 C 9.570312 9.707031 9.21875 10.058594 9.21875 10.488281 L 9.21875 12.441406 C 9.21875 12.871094 9.570312 13.222656 10 13.222656 C 10.429688 13.222656 10.78125 12.871094 10.78125 12.441406 L 10.78125 11.171875 C 12.128906 10.824219 13.125 9.597656 13.125 8.144531 C 13.125 6.421875 11.722656 5.019531 10 5.019531 Z M 10 5.019531 " />
              </svg>
              <div
                ref={tooltipRef}
                className={`tooltip__text${
                  showTooltip ? " show" : ""
                }${checkTooltipPosition()}`}
              >
                {auditReportTooltip}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="registered-firms__links-container">
        <a
          className="btn btn--primary"
          href={`https://rasr.pcaobus.org/Firms/FirmSummaryPublic.aspx?FirmID=${getField(
            item,
            "encodedfirmid"
          )}`}
        >
          Firm Summary
        </a>
        <a
          className="btn btn--hollow-primary"
          href={`/resources/auditorsearch/firms/?firmid=${getField(
            item,
            "firmid"
          )}`}
        >
          AuditorSearch Profile
        </a>
      </div>
    </div>
  );
}
